<script setup>
import BaseModal from "@/components/global-themed/BaseModal.vue";
import {computed, onMounted} from "vue";
import {useStore} from "vuex";
import ModalHeader from "@/components/global-themed/ui/modals/ModalHeader.vue";
import TourStepCounter from "@/components/tours/TourStepCounter.vue";
import DefaultButton from "@/components/global-themed/buttons/DefaultButton.vue";

const props = defineProps({
  tourId: {
    type: String,
    required: true,
  },
  steps: {
    type: Array,
    required: true,
  },
})

const store = useStore();

const showTourIntro = computed(() => store.getters['tours/showTourIntro'](props.tourId));

onMounted(() => {
  store.dispatch('tours/init', {tourId: props.tourId, steps: props.steps});
});

const goToNextStep = () => store.dispatch('tours/goToNextStep');

</script>

<template>
  <Teleport to=".tailwind">
    <BaseModal
      v-if="showTourIntro"
      modal-class="tw-max-w-lg tw-p-6"
      hide-close-button
    >
      <ModalHeader class="tw-align-center">
        <h3 class="tw-text-2xl tw-font-bold tw-text-neutral-900">
          <slot name="header" />
        </h3>
      </ModalHeader>

      <div class="tw-text-neutral-700 tw-text-base tw-my-8">
        <slot name="body" />
      </div>

      <div class="tw-flex tw-items-center tw-justify-between tw-p-4">
        <TourStepCounter class="tw-text-neutral-500" />
        <div class="tw-flex tw-items-center">
          <DefaultButton
            variant="primary"
            size="tooltip"
            @click="goToNextStep"
          >
            Next
          </DefaultButton>
        </div>
      </div>
    </BaseModal>
  </Teleport>
</template>